/**
 * Application Configuration
 * 
 * This file contains configuration values that can be changed after deployment.
 * It is checked into git (unlike .env files) for transparency and version control.
 */

const config = {
  // API Endpoints
  api: {
    // Lambda API Gateway endpoint for contact form submissions
    // Update this after deploying the Lambda and API Gateway
    contactFormEndpoint: 'https://d1v09xwk4i.execute-api.ap-southeast-2.amazonaws.com/default/ddconsult-contact-record-and-send-mail',

    // Existing backend API (FastAPI)
    // Leave empty to use relative paths (proxied through nginx/dev server)
    backendBaseUrl: '',
  },

  // Google reCAPTCHA v3
  recaptcha: {
    // Site key from Google reCAPTCHA console
    // Get one at: https://www.google.com/recaptcha/admin
    siteKey: '6LdDTUgsAAAAACM6ptYwRkLvsy1Vcrc8uuK49wnt',
    // Enable reCAPTCHA validation
    enabled: true,
  },

  // Feature flags
  features: {
    // Use Lambda endpoint for lead/contact form submissions
    // Set to true after Lambda deployment is complete
    useLambdaContactForm: true,
  },
};

export default config;
